module.exports = __webpack_public_path__ + "img/shiba-loading.f92d1162.png";